import { tran } from '../../../translations/schema/TranslationSchema.ts';

export const InputCommonTranslationSchema = tran.widget({
  label: tran.rte(),
  helpText: tran.rte(),
  placeholder: tran.string(),
  rules: tran.rules(),
});
